import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'

import WithSessionToken from './with-session-token'
import WithPassword from './with-password'
import {sendUsernamePassword, sendSessionToken, successful as recordToken} from './actions'

export const Authorisation = ({
  authorisation,
  sendSessionToken,
  sendUsernamePassword,
  recordToken,
  isEmbedded = false,
  isProdAdminEmbedded = true,
  children
}) => (
  authorisation.jwt ?
    children :
    (isEmbedded && isProdAdminEmbedded) ?
      <WithSessionToken
        sendSessionToken={sendSessionToken}
      /> :
      <WithPassword
        authorisation={authorisation}
        sendAuthorisation={sendUsernamePassword}
        recordToken={recordToken}
      />
)

const mapStateToProps = (state) => ({
  authorisation: state.authorisation
})

const mapDispatchToProps = (dispatch) => ({
  recordToken: (token) => {
    dispatch(recordToken({
      data: {
        token
      }
    }))
  },

  sendUsernamePassword: (payload) => {
    dispatch(sendUsernamePassword(payload))
  },
  sendSessionToken: (sessionToken) => {
    dispatch(sendSessionToken({
      sessionToken
    }))
  }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authorisation))



// WEBPACK FOOTER //
// ./src/authorisation/container.js